export const SET_CANVAS_LINE = 'SET_CANVAS_LINE';
export const UPDATE_DOCUMENT_FILE = 'UPDATE_DOCUMENT_FILE';
export const SET_FOCUS_SHARE_DOCUMENT = 'SET_FOCUS_SHARE_DOCUMENT';

export const REFRESH_IMAGE = 'REFRESH_IMAGE';
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";
export const SET_IS_WHITBOARD = 'SET_IS_WHITBOARD';

export const SHARE_DOCUMENT = 'SHARE_DOCUMENT';
export const SHARE_DOCUMENT_CANVAS_LINE = 'SHARE_DOCUMENT_CANVAS_LINE';
export const SHARE_DOCUMENT_DELETE_CANVAS_LINE = "SHARE_DOCUMENT_DELETE_CANVAS_LINE";

export const SET_DOCUMENT_FILE = 'SET_DOCUMENT_FILE';
export const SET_DOCUMENT_BUFFER = 'SET_DOCUMENT_BUFFER';
export const SET_CANVAS_ONE_LINE = 'SET_CANVAS_ONE_LINE';

export const SET_DELETE_ONE_LINE = 'SET_DELETE_ONE_LINE';
export const SET_DELETE_LINE = 'SET_DELETE_LINE';
export const SET_DELETE_KEY_LINE = 'SET_DELETE_KEY_LINE';